import { render, staticRenderFns } from "./MobileTopPart.vue?vue&type=template&id=8b9e7134"
import script from "./MobileTopPart.vue?vue&type=script&lang=js"
export * from "./MobileTopPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports